// utils/paymentLocal.ts
const KEY = "bbps_payment_ctx";

export type PaymentCtx = {
  refId: string;
  billerId: string;
  customerMobileNumber: string;
  customerParams: Record<string, string>;
};

export const savePaymentCtx = (ctx: PaymentCtx) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(ctx));
  } catch {
    return {};
  }
};

export const loadPaymentCtx = (): PaymentCtx | null => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as PaymentCtx) : null;
  } catch {
    return null;
  }
};
